// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importez vos fichiers de traductions
import translationEN from './locales/en/translation.json'; // Chemin d'accès à ajuster
import translationFR from './locales/fr/translation.json'; // Chemin d'accès à ajuster

// Les ressources de traduction
const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

i18n
  // Connectez le détecteur de langue au processus d'initialisation
  .use(LanguageDetector)
  // Passer i18n vers react-i18next.
  .use(initReactI18next)
  // Initialisation de i18next
  .init({
    resources,
    // La langue à utiliser si aucune langue n'est détectée ou spécifiée
    fallbackLng: 'en',
    // Activer le débogage en développement pour faciliter le dépannage
    debug: process.env.NODE_ENV === 'development',
    // Options de configuration pour le détecteur de langue
    detection: {
      // Ordre et où chercher la langue de l'utilisateur
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // Clés ou noms des cookies à vérifier
      lookupCookie: 'i18next',
      // Clés pour le stockage local à vérifier
      lookupLocalStorage: 'i18nextLng',
      // Option pour cacher la langue
      caches: ['localStorage', 'cookie'],
      // N'indexez pas les cookies pour les moteurs de recherche
      cookieMinutes: 10,
      // Seulement pour les langues dans la whitelist
      checkWhitelist: true
    },
    // Désactiver l'échappement de la valeur d'interpolation par défaut
    interpolation: {
      escapeValue: false // React échappe déjà par défaut
    }
  });

export default i18n;
